import * as React from 'react';
import { SVGProps } from 'react';

const IconToolsHoldCurveHoldSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M4 4v8a8 8 0 0 0 8 8h8" stroke="#B5E2FC" strokeWidth={2} />
    <path
      fill="var(--color-typo-primary)"
      d="M11 18h4v4h-4zM18 18h4v4h-4zM2 2h4v4H2zM2 10h4v4H2z"
    />
  </svg>
);
export default IconToolsHoldCurveHoldSizeM;
